import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spinning',
  templateUrl: './spinning.component.html',
  styleUrls: ['./spinning.component.css']
})
export class SpinningComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
